import "./src/styles/global.css"

/* Header: auf Startseite blendet Landing ihn in der Animationsreihe ein (4,5s); auf allen anderen Seiten sofort sichtbar */
export const onClientEntry = () => {
  if (typeof window === "undefined") return
  const pathname = window.location.pathname || ""
  const isIndex = pathname === "/" || pathname === ""
  if (!isIndex) {
    document.documentElement.classList.add("header-visible")
  }
}
